/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function t(n) {
  var o = {};

  for (var e in n) {
    if ("declaredClass" === e) continue;
    var r = n[e];
    if (null != r && "function" != typeof r) if (Array.isArray(r)) {
      o[e] = [];

      for (var _n = 0; _n < r.length; _n++) {
        o[e][_n] = t(r[_n]);
      }
    } else "object" == typeof r ? r.toJSON && (o[e] = JSON.stringify(r)) : o[e] = r;
  }

  return o;
}

export { t as mapParameters };